"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));

var _async = _interopRequireDefault(require("react-select/async"));

var _get = _interopRequireDefault(require("lodash/get"));

var _utils = require("../lib/utils");

var _selectUtils = _interopRequireDefault(require("../lib/selectUtils"));

var _inputFeedback = _interopRequireDefault(require("../inputFeedback/inputFeedback"));

var _customComponents = require("./customComponents");

require("./select.css");

var _excluded = ["type", "isInvalid", "disableInputFeedback", "groupLabelRenderer", "innerRef"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OrionSelectComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OrionSelectComponent, _React$Component);

  var _super = _createSuper(OrionSelectComponent);

  function OrionSelectComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OrionSelectComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addUserProvidedComponents", function (defaultComponents) {
      var customComponents = _this.props.customComponents;

      if ((0, _utils.isFunction)(customComponents)) {
        var userComponents = customComponents(_reactSelect.components);
        var userComponentsKeys = (0, _keys["default"])(userComponents);

        if (userComponentsKeys.length > 0) {
          (0, _forEach["default"])(userComponentsKeys).call(userComponentsKeys, function (componentKey) {
            defaultComponents[componentKey] = userComponents[componentKey];
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCustomComponents", function () {
      var _this$props = _this.props,
          hideDownArrow = _this$props.hideDownArrow,
          allowSelectDeselectAll = _this$props.allowSelectDeselectAll,
          isMulti = _this$props.isMulti,
          selectAllOption = _this$props.selectAllOption,
          footerRenderer = _this$props.footerRenderer;
      var defaultComponents = {};
      defaultComponents.LoadingIndicator = _customComponents.DefaultLoaderComponent;
      defaultComponents.Option = _customComponents.DefaultOptionComponent;

      _this.addUserProvidedComponents(defaultComponents);

      if (hideDownArrow) {
        defaultComponents.DropdownIndicator = _customComponents.HiddenDropdownIndicator;
        defaultComponents.IndicatorSeparator = _customComponents.HiddenDropdownSeparator;
      }

      if (allowSelectDeselectAll === true && isMulti === true) {
        defaultComponents.MenuList = _customComponents.SelectDeselectMenuList;
      }

      if (selectAllOption || footerRenderer) {
        defaultComponents.MenuList = _customComponents.OnlySelectAllMenuList;
      }

      return defaultComponents;
    });
    _this.selectUtils = new _selectUtils["default"]();
    _this.selectRef = props.innerRef || /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(OrionSelectComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          isInvalid = _this$props2.isInvalid,
          disableInputFeedback = _this$props2.disableInputFeedback,
          groupLabelRenderer = _this$props2.groupLabelRenderer,
          innerRef = _this$props2.innerRef,
          attr = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var Tag = {
        async: _async["default"],
        "async-creatable": _asyncCreatable["default"],
        creatable: _creatable["default"],
        select: _reactSelect["default"]
      }[type];

      if (!Tag) {
        throw new Error("Unsupported Select type: ".concat(type));
      }

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
          "aria-label": attr.name || "select dropdown",
          className: (0, _utils.gatherClasses)(this.props, "oui-select", isInvalid ? "oui-is-invalid" : null),
          classNamePrefix: "oui-select",
          menuIsOpen: attr.isMenuOpenAtStart || undefined
        }, this.selectUtils.getFilterOption(attr, type), this.selectUtils.getMenuPortalTarget(attr), this.selectUtils.getPropsForType(attr, type), this.selectUtils.getNoOptionsMessage(attr, type), {
          styles: this.selectUtils.getSelectStyles(attr.styles),
          onChange: function onChange(values, meta) {
            var changedValue = values;

            if ((0, _utils.isObject)(attr.selectAllOption) && attr.selectAllOption.label && attr.selectAllOption.value && attr.isMulti === true) {
              if (values.length > 0 && values[0].value === attr.selectAllOption.value) {
                changedValue = (0, _slice["default"])(values).call(values, 1);
              }
            }

            if (attr.validationProps && attr.validationProps.setFieldValue && attr.name) {
              attr.validationProps.setFieldValue(attr.name, changedValue, true);
            }

            return attr.onChange(changedValue, meta);
          },
          onBlur: function onBlur() {
            if (attr.validationProps && attr.validationProps.setFieldTouched && attr.name) {
              attr.validationProps.setFieldTouched(attr.name);
            }
          },
          components: this.getCustomComponents(),
          ref: this.selectRef,
          internalRef: this.selectRef,
          closeMenuOnSelect: !attr.isMulti,
          hideSelectedOptions: attr.isMulti,
          formatGroupLabel: function formatGroupLabel(data) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _utils.gatherClasses)(null, "oui-select__group-heading-inner", !groupLabelRenderer && !data.label ? "oui-pb-0 oui-pt-2" : "")
            }, (0, _utils.isFunction)(groupLabelRenderer) ? groupLabelRenderer(data) : data.label);
          },
          userProps: {
            onChange: attr.onChange,
            validationProps: attr.validationProps,
            name: attr.name,
            selectAllButtonText: attr.selectAllButtonText,
            selectAllOption: attr.selectAllOption,
            selectAllOptionDisabled: attr.selectAllOptionDisabled,
            selectAllOptionDisabledTooltip: attr.selectAllOptionDisabledTooltip,
            footerRenderer: attr.footerRenderer,
            isMulti: attr.isMulti
          }
        })), !disableInputFeedback && attr.validationProps && /*#__PURE__*/_react["default"].createElement(_inputFeedback["default"], {
          show: isInvalid,
          message: (0, _get["default"])(attr.validationProps.errors, attr.name)
        }))
      );
    }
  }]);
  return OrionSelectComponent;
}(_react["default"].Component);

var OrionSelect = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(OrionSelectComponent, (0, _extends2["default"])({}, props, {
    innerRef: ref
  }));
});

OrionSelect.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })).isRequired,
  type: _propTypes["default"].oneOf(["async", "async-creatable", "creatable", "select"]),
  isInvalid: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  filterConfig: _propTypes["default"].shape({
    ignoreCase: _propTypes["default"].bool,
    ignoreAccents: _propTypes["default"].bool,
    trim: _propTypes["default"].bool,
    matchFrom: _propTypes["default"].oneOf(["start", "any"])
  }),
  inputValue: _propTypes["default"].string,
  isClearable: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isMulti: _propTypes["default"].bool,
  isSearchable: _propTypes["default"].bool,
  noOptionsMessage: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onCreateOption: _propTypes["default"].func,
  onInputChange: _propTypes["default"].func,
  openMenuOnClick: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].any,
  defaultValue: _propTypes["default"].any,
  defaultOptions: _propTypes["default"].any,
  loadOptions: _propTypes["default"].func,
  cacheOptions: _propTypes["default"].bool,
  customComponent: _propTypes["default"].func,
  disableInputFeedback: _propTypes["default"].bool,
  menuPlacement: _propTypes["default"].oneOf(["auto", "bottom", "top"]),
  menuPosition: _propTypes["default"].oneOf(["absolute", "fixed"]),
  maxMenuHeight: _propTypes["default"].number,
  debounceDelay: _propTypes["default"].number,
  isLoading: _propTypes["default"].bool,
  innerRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].func]),
  selectAllOptionDisabled: _propTypes["default"].bool,
  selectAllOptionDisabledTooltip: _propTypes["default"].string,
  isOptionDisabled: _propTypes["default"].func
};
OrionSelect.defaultProps = {
  type: "select",
  options: [],
  isInvalid: false,
  autoFocus: false,
  isDisabled: false,
  isMulti: false,
  isSearchable: true,
  placeholder: "Select",
  cacheOptions: false,
  openMenuOnClick: true,
  disableInputFeedback: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  menuPlacement: "auto",
  menuPosition: "absolute",
  maxMenuHeight: 200,
  isMenuOpenAtStart: false,
  debounceDelay: 0
};
OrionSelect.displayName = "OrionSelect";
var _default = OrionSelect;
exports["default"] = _default;